import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";

export default function useReveal(options = {}) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2, rootMargin: "0px 0px -8% 0px", ...options });
  const nodeRef = useRef(null);
  const [forced, setForced] = useState(false);

  const setRefs = useCallback(
    (node) => {
      nodeRef.current = node;
      ref(node);
    },
    [ref]
  );

  useLayoutEffect(() => {
    const node = nodeRef.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) setForced(true);
  }, []);

  useEffect(() => {
    if (inView || forced) return undefined;
    const timer = setTimeout(() => setForced(true), 700);
    return () => clearTimeout(timer);
  }, [inView, forced]);

  const on = inView || forced;
  return [setRefs, on, on ? "is-in" : ""];
}
